<template>
  <v-navigation-drawer
    id="mainNav"
    v-model="drawerChild"
    :width="navWidth"
    fixed
    app
    class="o-hidden"
    :mobile-breakpoint="$navMobileBreakpoint"
  >
    <div
      ref="navContainer"
      class="height-100vh pos-rel o-auto"
    >
      <div class="">
        <div class="d-flex ml-6 mt-3">
          <router-link
            to="/"
            class=""
          >
            <v-img
              alt="logo"
              class="shrink mt-3"
              contain
              src="../assets/logo-for-dark-bg.svg"
              transition="scale-transition"
              width="10.5rem"
            />
          </router-link>
        </div>

        <v-container fluid>
          <v-row align="center">
            <v-col class="d-flex justify-center mx-3">
              <h3
                v-if="!isAdmin"
                class="account-name"
              >
                {{ account.shortName || '&nbsp;' }}
              </h3>
              <v-select
                v-else
                dark
                :items="[account.shortName || '']"
                :value="account.shortName || ''"
                outlined
                dense
                hide-details
                flat
              />
            </v-col>
          </v-row>
        </v-container>

        <v-list
          :ref="'navList'"
          dense
          class="pt-0 mx-2"
          flat
        >
          <template v-for="(item, i) in navItemsFiltered">
            <v-divider
              v-if="item.divider"
              :key="`divider-${i}`"
              class="my-1"
            />

            <nav-sub-list
              v-else-if="item.group"
              :key="`group-${i}`"
              :item="item"
            />

            <nav-item
              v-else
              :key="`item-${i}`"
              :icon="item.icon"
              :text="item.text"
              :header="item.header"
              :to="item.to"
            />
          </template>

          <nav-item
            :avatar="user.photoURL || '/img/noavatar.jpg'"
            :text="user.displayName"
            @click="loadProfile"
          />
          <nav-item
            text="Logout"
            @click="logout"
          />
        </v-list>

        <!-- TODO replace with profile page -->
        <component
          :is="'ProfileCard'"
          v-if="profileLoaded"
          :show-bio="true"
          :dialog-view="profileLoaded"
          :profile-user="$store.state.appUser"
          @close="profileLoaded = false"
        />
      </div>
    </div>
    <v-footer
      fixed
      class="darkbg white--text"
    >
      <v-row>
        <v-col>
          <terms-and-conditions-link class="white--text" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <privacy-policy-link class="white--text" />
        </v-col>
      </v-row>
    </v-footer>
  </v-navigation-drawer>
</template>

<script>
import kebabCase from 'lodash/kebabCase'

import navItems from '@/components/navItems'
import NavSubList from '@/components/NavSubList'
import NavItem from '@/components/NavItem'
import PrivacyPolicyLink from '@/components/PrivacyPolicyLink'
import TermsAndConditionsLink from '@/components/TermsAndConditionsLink'

const ProfileCard = () => import('@/components/ProfileCard')
const _ = { kebabCase }

export default {
  name: 'Navigation',
  components: {
    ProfileCard,
    NavSubList,
    NavItem,
    TermsAndConditionsLink,
    PrivacyPolicyLink
  },
  props: {
    navWidth: { type: Number, default: 0 },
    drawer: { type: Boolean, default: null }
  },
  data: () => ({
    menu: {},
    navItems: navItems,
    profileLoaded: false,
    drawerChild: null
  }),
  computed: {
    navItemsFiltered() {
      return this.navItems.filter(this.checkPerms)
    }
  },
  watch: {
    drawerChild: function (newVal, oldVal) {
      this.$emit('update:drawer', newVal)
    },
    drawer: function (newVal, oldVal) {
      this.drawerChild = newVal
    }
  },
  async beforeCreate() {
    this._ = _
    this.dispatchActions(['get_appUser', 'get_account', 'get_featureToggles'])
    this.mapStates(['account', 'user'])
    this.mapGetters(['isAdmin'])
  },
  methods: {
    loadProfile() {
      this.profileLoaded = true
    },
    logout() {
      this.$store.dispatch('LOGOUT')
    },
    checkPerms(item) {
      if (item.for) {
        if (!item.for(this.$store.getters)) {
          return false
        }
      }
      if (item.children) {
        return item.children.every(this.checkPerms)
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.v-navigation-drawer {
  background-color: var(--v-darkbg-base);
  color: white;
}

.account-name {
  color: white;
}
</style>
